// src/containers/Codes/CodeSet.js


class CodeSet {
  constructor(name, translations={ fr: '', it: '', es: '', de: '', da: '', nl: '', no: '', sv: '' }) {
    this.translations = { ...translations, en: name };
    this.data = {};
    this.lang = 'en'  // defaults to english
  }

  setLang(lang){
    this.lang = lang;
  }

  get name(){
    return this.translations[this.lang];
  }

  addData(key, data) {
    const normalizedData = {};
    for (const [prop, value] of Object.entries(data)) {
      if (typeof value === 'object' && value !== null) {
        normalizedData[prop] = { ...value, en: value.en || null };
      } else {
        normalizedData[prop] = value;
      }
    }
    this.data[key] = normalizedData;
  }

  // Given a key, it returns the name value
  getValue(key, lang) {
    return this.data[key]?.name[lang]
  }

  // Returns an obj with nested objs for a specific language
  get trimNamed() {
    const trimmedData = {};
    for (const [key, value] of Object.entries(this.data)) {
      if (value.name && value.name[this.lang]) {
        trimmedData[key] = value.name[this.lang];
      } else if (value.name && value.name['en']) {
        // Default to English if the selected language is not available
        trimmedData[key] = value.name['en'];
      }
    }
    return trimmedData;
  }

  // Returns { 0: { en: '', es: '', fr: '', it: '' }, 1: { en: '', es: '', fr: '', it: '' } }
  get extractNames(){
    const transformedObj = {};
    for (const key in this.data) {
      if (this.data.hasOwnProperty(key)) {
        transformedObj[key] = this.data[key].name;
      }
    }
    return transformedObj;
  }

  // NEW: Given a key, it returns the ISO code
  getISOCode(key) {
    return this.data[key]?.isoCode || null;
  }

  // Given an array of keys, it will return an array of words. E.g. [0,1] -> ['beige','red']
  getNamesByKeys(keys, lang = this.lang) {
    return keys.map(key => {
      const item = this.data[key];
      if (!item) {
        return null; // or you could return a default value or throw an error
      }
      return item.name[lang] || item.name['en'] || null;
    });
  }

  // given the name value in any language, return the key of it e.g. input: 'classic' will return 0
  getKeyByName(value) {
    for (const [key, data] of Object.entries(this.data)) {
      if (data.name) {
        for (const langValue of Object.values(data.name)) {
          if (langValue === value) {
            return key;
          }
        }
      }
    }
    return null; // Return null if no match is found
  }
}

export default CodeSet;


// https://nanimarquina.com/en/pages/guia-de-medidas
// export const sizes = ['xxs', 'xs', 's', 'm', 'l', 'xl', 'xxl'];
// xxs =
// xs =
// s = 180x120?
// m = 240x170
// l = 300x200
// xl =
// xxl =

/*export const productTypes = {
    0: 'hand-made',
    1: 'machine-made',
    2: 'leather',
    3: 'babucha',
}*/

// export const misc = {
//     0: 'Extra-ordinary',
//     1: 'Runner / corridor',
//     2: 'No fringes',
// //    3: 'Has twin',
// }

// https://nanimarquina.com/en/pages/guia-de-medidas
// export const sizes = ['xxs', 'xs', 's', 'm', 'l', 'xl', 'xxl'];
// xxs =
// xs =
// s = 180x120?
// m = 240x170
// l = 300x200
// xl =
// xxl =

// text:
//   <>
//     <p>Persian rugs are highly regarded for their exceptional quality, intricate designs, and rich cultural heritage. What sets them apart from other rugs is a combination of factors that contribute to their uniqueness.</p>
//     <p>First and foremost, Persian rugs are known for their authenticity. They are meticulously hand-woven in Iran, a country formerly known as Persia, by skilled artisans who have inherited their weaving techniques from previous generations. The craftsmanship involved in creating these rugs is a testament to their authenticity and sets them apart from machine-made rugs.</p>
//     <p>Another distinguishing characteristic of Persian rugs lies in the materials used and the dyeing process. These rugs are typically crafted from high-quality materials such as wool, silk, or a blend of both. Natural dyes derived from plants, minerals, and even insects are employed to achieve the vibrant and long-lasting colors that Persian rugs are renowned for. This traditional dyeing practice adds a level of authenticity and depth to the rugs.</p>
//     <p>The designs and patterns found on Persian rugs are a key element that sets them apart. These rugs feature intricate patterns and designs that draw inspiration from a variety of sources, including nature, geometric shapes, historical events, and cultural symbols. Each design carries its own symbolic meaning and reflects the creativity and cultural influences of the specific region it originates from. This attention to detail and storytelling through the designs distinguishes Persian rugs from others.</p>
//     <p>The knotting technique used in the weaving process is another factor that contributes to the uniqueness of Persian rugs. They are woven using different knotting techniques, with the asymmetrical (Persian) knot and the symmetrical (Turkish) knot being the most commonly employed. The density of the knots and the complexity of the design greatly impact the overall quality and value of the rug.</p>
//     <p>Furthermore, Persian rugs exhibit regional variations, each with its own distinct style and characteristics. Different regions in Iran produce their own types of Persian rugs, such as Tabriz, Isfahan, Kashan, Heriz, and Qom. These rugs showcase unique weaving traditions, motifs, and color palettes, adding to the diversity and appeal of Persian rugs.</p>
//     <p>Finally, Persian rugs are often considered valuable investments. Their enduring quality and the scarcity of genuinely handcrafted rugs contribute to their desirability among collectors and enthusiasts. Over time, authentic Persian rugs tend to appreciate in value, making them sought after as both functional decor pieces and long-term investments.</p>
//     <p>It{"'"}s important to note that the term {'"'}Persian rug{'"'} specifically refers to rugs made in Iran. While there are many rugs made in similar styles outside of Iran, they are not technically considered Persian rugs due to their origin.</p>
//   </>,

/*export const productTypes = {
    0: 'hand-made',
    1: 'machine-made',
    2: 'leather',
    3: 'babucha',
}*/

// export const fabricantes = {
//     0: 'Louis de Poortere',
//     1: 'Universal XXI',
//     2: 'Sualsa',
//     3: 'Osta Carpet',
//     4: 'Santos Monteiro',
//     5: 'Kuatro Carpets',
//     6: 'Sitap',
//     7: 'Ligne Pure',
//     8: 'Lusotufo',
//     9: 'Naturtex',
//     10: 'Alfombras Confort',
//     11: 'Obsession',
//     12: 'Pipsa',
// }
